export default {
  methods: {
    isAnObject(object) {
      if (object === null) {
        return false;
      }
      return (typeof object === 'object');
    },

    isSameObject(object, base) {
      // If empty object is compared with null, then return true
      if (!base && this.isAnObject(object)) {
        if (Object.keys(object).length === 0) {
          return true;
        }
        return false;
      }

      // Compare each key of the base object
      for (const [key, value] of Object.entries(object)) {
        if (
          (this.isAnObject(object[key]) && this.isAnObject(base[key]) && !this.isSameObject(object[key], base[key]))  // different objects
          || (!this.isAnObject(object[key]) && !this.isAnObject(base[key]) && object[key] !== base[key])              // different values
          || (base[key] === null && this.isAnObject(object[key]) && !this.isSameObject(object[key], base[key]))     // base null and object possibly empty
        ) {
          return false;
        }
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/difference.js